import axios from "axios";
import {useQuery} from "@tanstack/vue-query";

const fetchSuggestions = (city, distance) =>  useQuery({
  queryKey: ['location-suggestions', city, distance],
  queryFn: async () => {
    if (!city.value || !distance.value) {
      return [];
    }

    const query = new URLSearchParams();

    query.append('city', city.value);
    query.append('distance', distance.value);

    const { data } = await axios.get(`/ajax/v2/ai-onboarding/location-suggestions?` + query.toString());

    return data.data;
  },
});

export {
  fetchSuggestions,
}
